module.exports = __webpack_public_path__ + "assets/events_coup_white.c6ff7c77.svg";